var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("001")]),_c('h1',[_vm._v("VIP "+_vm._s(_vm.$route.params.id)+" 活动页面")])])}
var staticRenderFns = []

export { render, staticRenderFns }